import { IDeleteEntity } from "interfaces/delete-entity";
import { GraphQLData } from "interfaces/graphql-data";
import { ITenant } from "interfaces/tenant";

export class DeleteEdgeModel implements IDeleteEntity, GraphQLData {
  lastEvaluatedKey: string = '';
  deleted: boolean = false;

  public static create(
    deleted: boolean) : DeleteEdgeModel {
    const t = new DeleteEdgeModel();
    t.deleted = deleted;
    return t;
  }

  async hydrate(data: any, tenant: ITenant): Promise<void> {
    //..
    // data.data.GetTenant.Deleted (true)
    console.log(data);
    if (data && data.data && data.data.GetEdge && data.data.GetEdge.Delete) {
      this.deleted = data.data.GetEdge.Delete;
    } else {
      throw new Error('data structured passed in does not contain data, data.data, data.data.GetEdge or data.data.GetEdge.Delete');
    }
  }
}